import { useRef, useEffect } from 'react';
import { Grid } from '@gusto/workbench';
import {
  NumberStates,
  PreviousPayrollProvider,
  WhatToUse,
  WhoToPay,
  SurveyQuestionsKeys,
} from 'packages/signup/components/SurveyQuestions';
import type {
  PrevPayrollProviderValues,
  WhoToPayValues,
  NumberStatesValues,
  WhatToUseValues,
  WhatToUseFindYourPlanValues,
} from 'packages/signup/components/SurveyQuestions';
import trackViewedPages from 'packages/signup/components/explore/trackViewedPages';
import UnifiedLearnMoreJourneyQuestionsFormObserver from 'packages/signup/components/explore/UnifiedLearnMoreJourneyObserver';

export type LearnMoreSurveyQuestionsType = {
  whoToPay?: WhoToPayValues;
  numberStates?: NumberStatesValues;
  prevPayrollProvider?: PrevPayrollProviderValues;
  whatToUse?: WhatToUseValues | string[];
  whatToUseFindYourPlan?: WhatToUseFindYourPlanValues | string[];
};

export type LearnMoreSurveyQuestionsValues = {
  whoToPay?: WhoToPayValues;
  numberStates: NumberStatesValues;
  prevPayrollProvider?: PrevPayrollProviderValues;
  whatToUse?: WhatToUseValues;
  whatToUseFindYourPlan?: WhatToUseFindYourPlanValues;
};

export default function UnifiedLearnMoreJourneyQuestions({
  removeFirstThreeQuestions = false,
}: {
  removeFirstThreeQuestions?: boolean;
}) {
  useEffect(() => {
    if (removeFirstThreeQuestions) {
      trackViewedPages([SurveyQuestionsKeys.WHAT_TO_USE]);
    } else {
      trackViewedPages([
        SurveyQuestionsKeys.WHO_TO_PAY,
        SurveyQuestionsKeys.NUMBER_STATES,
        SurveyQuestionsKeys.PREV_PAYROLL_PROVIDER,
        SurveyQuestionsKeys.WHAT_TO_USE,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const whoToPayRef = useRef(null);
  const numberStatesRef = useRef(null);
  const prevPayrollProviderRef = useRef(null);
  const whatToUseRef = useRef(null);

  const renderQuestionContent = () => {
    let content;

    if (removeFirstThreeQuestions) {
      content = (
        <Grid maxWidth={632} autoRows="max-content" rowGap={12}>
          <WhatToUse ref={whatToUseRef} />
        </Grid>
      );
    } else {
      content = (
        <Grid maxWidth={632} autoRows="max-content" rowGap={12}>
          <WhoToPay ref={whoToPayRef} />
          <NumberStates ref={numberStatesRef} />
          <PreviousPayrollProvider ref={prevPayrollProviderRef} />
          <WhatToUse ref={whatToUseRef} />
        </Grid>
      );
    }

    return content;
  };

  return (
    <>
      <UnifiedLearnMoreJourneyQuestionsFormObserver />
      {renderQuestionContent()}
    </>
  );
}
